export const DOMAIN = 'InputsAsArray';
